// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result[data-v-fd178de4]{display:block;padding:.5rem 0;font-size:.9375rem;line-height:1rem}.result[data-v-fd178de4],.result[data-v-fd178de4]:visited:not(:hover){text-decoration:none;color:#333}.result[data-v-fd178de4]:hover{color:var(--cta-color)}.result[data-v-fd178de4]{text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
